"function"!=typeof Promise&&require("promise-polyfill/dist/polyfill");


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/lib/polyfills/es6Promise.js
// module id = 2dLV
// module chunks = 0